module.exports = __webpack_public_path__ + "img/IMG20230525095621.db1350cc.jpg";